<div class="flight-extras-container">
  <div class="half-container">
    <div class="half-block">
      @if (loyaltyCode) {
        <label i18n="@@loyaltyNumber2">Loyalty Number</label>
      } @else {
        <label i18n="@@EnterloyaltyNumber">Enter {{ operatingCarrierName }} Loyalty Number </label>
      }
      <input
        appInput
        [border]="true"
        [noIcon]="true"
        type="text"
        [value]="loyaltyCode"
        (input)="updateLoyaltyCode($event)"
      />
    </div>
    <div class="half-block">
      <label i18n="@@DOB_loyalty" for="dobLoyalty">Date of Birth</label>
      <i class="ico-calendar combo-box-icon cursor_pointer" aria-hidden="true"></i>
      <input
        autocomplete="off"
        appInput
        [border]="true"
        class="combo-box"
        i18n-placeholder
        placeholder="Select date of birth"
        name="dp"
        [displayMonths]="deviceDetector.displayMonths"
        [minDate]="minDate"
        [maxDate]="maxDate"
        [startDate]="startDate"
        [(ngModel)]="chosenDob"
        [navigation]="'select'"
        ngbDatepicker
        #dp
        container="body"
        #d="ngbDatepicker"
        (ngModelChange)="loyaltyCheckWithDob()"
        (click)="d.toggle()"
        firstDayOfWeek="7"
        tabindex="0"
        [required]="dobMandatory"
        id="dobLoyalty"
        weekdays="short"
      />
    </div>
    <div class="recalculate-container">
      <button
        type="button"
        appButton="small"
        [disabled]="!recalcActive || (this.dobMandatory && !this.chosenDob)"
        id="recalculate-button"
        i18n="@@Recalculate"
        (click)="recalcuateSeats()"
      >
        Recalculate
      </button>
      <button
        type="button"
        class="accessible-tooltip-trigger ico ico-info-circle info-button"
        i18n-ngbTooltip
        ngbTooltip="A change has been made to the Loyalty input field, click on the recalculate button to ensure your membership benefits are applied"
        attr.aria-label="A change has been made to the Loyalty input field, click on the recalculate button to ensure your membership benefits are applied"
        triggers="manual"
        #ttHint="ngbTooltip"
        (mouseenter)="ttHint.open()"
        (focus)="ttHint.open()"
        (blur)="ttHint.close()"
        (click)="ttHint.toggle()"
      >
        <span class="visuallyhidden"
          >A change has been made to the Loyalty input field, click on the recalculate button to
          ensure your membership benefits are applied</span
        >
      </button>
    </div>
  </div>
</div>
